import { render, staticRenderFns } from "./FilterCategory.vue?vue&type=template&id=635cadc2&scoped=true"
import script from "./FilterCategory.vue?vue&type=script&lang=ts"
export * from "./FilterCategory.vue?vue&type=script&lang=ts"
import style0 from "./FilterCategory.vue?vue&type=style&index=0&id=635cadc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635cadc2",
  null
  
)

export default component.exports